import axios from 'axios';
import csrf from './csrf';

// If we want to do Ajax POST requests we need the CSRF token from Rails.
if (csrf.token) {
  axios.defaults.headers.common[csrf.headerKey] = csrf.token;
}

// Allows Rails to see these requests as Ajax (xhr? will be true)
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default axios;
